<div id="rd_tr_card-content" [formGroup]="form" fxLayout="column" fxLayoutGap="1rem">

  <div class="flex-wrap">
    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_MARKT_STAMMDATENREGISTER_NUMMER"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>MaStR-Nr. Einheit</mat-label>
      <input formControlName="maStRegNr"
        data-qa="maStRegNr"
        [redispatchDisableControl]="disabled || readonly"
        matInput
        name="tr_maStRegNr">
      @if (f.maStRegNr.hasError('minlength') || f.maStRegNr.hasError('maxlength')) {
        <mat-error>
          Die MaStR-Nr. ist {{ MASTREGNR_LENGTH }} Zeichen lang.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_ANLAGEN_TYPE"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Typ SEE-SSE</mat-label>
      <mat-select formControlName="anlagenType"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="anlagenType"
        name="tr_anlagenType">
        @for (item of EnergietraegerTypeItems; track item.key) {
          <mat-option
            [value]="item.key">{{ item.description }}
          </mat-option>
        }
      </mat-select>
      @if (f.anlagenType.hasError('required')) {
        <mat-error>
          Bitte wählen sie einen Typen aus.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_ZUORDNUNG_SPEICHER"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Zuordnung eines Speichers</mat-label>
      <input formControlName="zuordnungSpeicher"
        [redispatchSplitter]="SPEICHER_SEPARATOR"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="zuordnungSpeicher"
        matInput
        name="tr_zuordnungSpeicher">
    </mat-form-field>
  </div>

  <div class="flex-wrap">
    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AB_NAME"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Anlagenbetreiber Name</mat-label>
      <input formControlName="anlagebetreiberName"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="anlagebetreiberName"
        matInput
        name="tr_anleagebetreiberName">
      @if (f.anlagebetreiberName.hasError('required')) {
        <mat-error>
          Bitte geben Sie einen Name ein.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AB_STRASSE"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Anlagenbetreiber Str.</mat-label>
      <input formControlName="anlagebetreiberStrasse"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="anlagebetreiberStrasse"
        matInput
        name="tr_anlagebetreiberStrasse">
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AB_HNR"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Anlagenbetreiber Hausnummer</mat-label>
      <input formControlName="anlagebetreiberHausnummer"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="anlagebetreiberHausnummer"
        matInput
        name="tr_anlagebetreiberHausnummer">
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AB_HNR_ZUSATZ"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Anlagenbetreiber Hausnummerzusatz</mat-label>
      <input formControlName="anlagebetreiberHausnummerZusatz"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="anlagebetreiberHausnummerZusatz"
        matInput
        name="tr_anlagebetreiberHausnummerZusatz">
    </mat-form-field>
  </div>

  <div class="flex-wrap">
    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AB_PLZ"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Anlagenbetreiber PLZ</mat-label>
      <input formControlName="anlagebetreiberPLZ"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="anlagebetreiber-plz"
        matInput
        name="tr_anlagebetreiberPLZ">
      @if (f.anlagebetreiberPLZ.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Postleitzahl ein
        </mat-error>
      }
      @if (f.anlagebetreiberPLZ.getError('minlength'); as error) {
        <mat-error>
          Postleitzahl zu kurz ({{ error.requiredLength }})
        </mat-error>
      }
      @if (f.anlagebetreiberPLZ.getError('maxlength'); as error) {
        <mat-error>
          Postleitzahl zu lang ({{ error.requiredLength }})
        </mat-error>
      }
      @if (f.anlagebetreiberPLZ.hasError('pattern')) {
        <mat-error>
          Postleitzahl ungültig. Sie können eine 3 bis 8-stellige Postleitzahl eingeben. Internationale
          Postleitzahlen sind möglich.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AB_ORT"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Anlagenbetreiber Ort</mat-label>
      <input formControlName="anlagebetreiberOrt"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="anlagebetreiberOrt"
        matInput
        name="tr_anlagebetreiberOrt">
      @if (f.anlagebetreiberOrt.hasError('required')) {
        <mat-error>
          Bitte geben Sie einen Ort ein.
        </mat-error>
      }
    </mat-form-field>
  </div>
</div>
